import { SUBSCRIPTION_PACKAGES_ENDPOINT, SUBSCRIPTION_PACKAGES_STATS_ENDPOINT } from '../api-services/ApiEndpoints';

export const getSubscriptionPackages = async () => {
    const url = `${process.env.REACT_APP_API_URL}${SUBSCRIPTION_PACKAGES_ENDPOINT}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return await response.json();
};

export const getPackageStatistics = async () => {
    const url = `${process.env.REACT_APP_API_URL}${SUBSCRIPTION_PACKAGES_STATS_ENDPOINT}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return await response.json();
};

export const createSubscriptionPackage = async (packageData) => {
    const url = `${process.env.REACT_APP_API_URL}${SUBSCRIPTION_PACKAGES_ENDPOINT}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(packageData)
    });
    return await response.json();
};

export const updateSubscriptionPackage = async (id, packageData) => {
    const url = `${process.env.REACT_APP_API_URL}${SUBSCRIPTION_PACKAGES_ENDPOINT}/${id}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(packageData)
    });
    return await response.json();
};

export const deleteSubscriptionPackage = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${SUBSCRIPTION_PACKAGES_ENDPOINT}/${id}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return await response.json();
};
